import React from 'react';

interface StatItem {
  label: string;
  value: string | number;
  suffix?: string;
  status?: 'good' | 'warning' | 'bad';
}

interface TopStatsProps {
  items: StatItem[];
}

const statusColors: Record<string, string> = {
  good: 'var(--success)',
  warning: 'var(--warning)',
  bad: 'var(--danger)',
};

const TopStats: React.FC<TopStatsProps> = ({ items }) => {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: `repeat(${Math.min(items.length, 6)}, 1fr)`,
        gap: 16,
        marginBottom: 20,
      }}
    >
      {items.map((item, index) => (
        <div
          key={index}
          style={{
            background: 'var(--card-bg)',
            border: '1px solid var(--border-color)',
            borderRadius: 'var(--radius)',
            padding: '16px 12px',
            textAlign: 'center',
            boxShadow: 'var(--shadow-sm)',
          }}
        >
          <div style={{
            fontSize: 24,
            fontWeight: 700,
            color: item.status ? statusColors[item.status] : 'var(--title-color)',
            lineHeight: 1.2,
            fontFamily: 'var(--font-mono)',
            fontFeatureSettings: '"tnum"',
          }}>
            {item.value}
            {item.suffix && (
              <span style={{ fontSize: 13, fontWeight: 400, marginLeft: 2, color: 'var(--text-secondary)' }}>
                {item.suffix}
              </span>
            )}
          </div>
          <div style={{
            fontSize: 11,
            color: 'var(--text-secondary)',
            marginTop: 6,
            textTransform: 'uppercase',
            letterSpacing: 0.5,
            fontWeight: 500,
          }}>
            {item.label}
          </div>
        </div>
      ))}
    </div>
  );
};

export default TopStats;
